<template>
    <div>
    <!-- 和曲线图是一个组件 -->
    <!--mescroll滚动区域的基本结构-->
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">

    <!-- 网络异常tips -->
    <div class="tips" v-show="this.$store.state.tips"><span>网络异常！请检查网络设置或下拉刷新</span></div>
    <div class="goldtitle">
        <p style="position:relative;">
            <span @click="handleicon">{{this.$store.state.goldindex?'伦敦金':'伦敦银'}}</span><span><img :style="{transform: !icontoggle ? 'rotate(0deg)' : 'rotate(180deg)'}" src="@/assets/icon-down.png" alt=""></span>
        </p> 
            <p v-if="(this.$store.state.goldSell || this.$store.state.silverSell) == 0">-.--   -.--</p>   
            <p v-else-if="(!this.goldclose || !this.silverclose)">-.--   -.--</p>
            <p v-else :style="{color: this.$store.state.goldindex && this.getTomgoldprice >= 0?'#FF4F36':(!this.$store.state.goldindex && this.getTomsilverprice >= 0?'#FF4F36':'#17CF84')}">
                <span>{{this.$store.state.goldindex?parseFloat(this.$store.state.goldSell).toFixed(2):parseFloat(this.$store.state.silverSell).toFixed(3)}}</span> 
                <span>{{this.$store.state.goldindex?this.getTomgoldprice:this.getTomsilverprice}}</span> 
                <span>{{this.$store.state.goldindex?this.getgoldclose:getsilverclose}}</span>
            </p>
            <ul class="slideDown" v-show="icontoggle">
                <div class="tab-icon"></div>
                    <div class="tab-item" v-for="(tab,index) in tabs" :key="index">
                        <li @click="handleli(index)">{{tab.name}}</li>
                    </div>
            </ul>
        <!-- <p><span>收起</span><span><img src="@/assets/slideup.png" alt=""></span></p> -->
    </div>

    <gold v-show="this.$store.state.goldindex"></gold>
    <silver v-show="!this.$store.state.goldindex"></silver>
    <!-- <gold  :text='text' v-show="this.$store.state.goldindex"></gold>
    <silver :text='text' v-show="!this.$store.state.goldindex"></silver> -->


    </mescroll-vue>

    </div>
    
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import axios from 'axios'
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
import pako from 'pako'
import {getsymbol,openhq,allhq,get_all_symbols_quote,utf8ByteToUnicodeStr} from '@/utils/socket2.js';
import Gold from '../components/gold.vue'
import Silver from '../components/silver.vue'
export default {
    components:{
        Gold,
        Silver,
        MescrollVue // 注册mescroll组件
    },
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    name:"deals",
    data(){
        return{
            onLine: navigator.onLine, //监听网络状态

            goldclose:null,//金价昨收
            silverclose:null,//银价昨收

            // getgoldclose:null,   
            // getsilverclose:null,
               
            // currentIndex:0,
            changeArr:[{'name':'市价交易'},{'name':'挂单交易'}],
            icontoggle:false,
            // text:'伦敦金',
            tabs: [{name: '伦敦金',},{name: '伦敦银',}],

            mescroll: null, // mescroll实例对象
			mescrollDown:{
                auto:false,
                callback:this.downCallback
            }, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
			mescrollUp: { // 上拉加载的配置.
                use:false,
                auto:false,
			},

        }
    },

    methods:{

        // 切换伦敦金银
        handleli(index){
            // this.text = this.tabs[index].name
            // this.currentIndex = index
            this.icontoggle = !this.icontoggle
            if(index == 0){
                this.$store.state.goldindex = true

            }else if(index == 1){
                this.$store.state.goldindex = false
 
            }
        },
        handleicon(){
            this.icontoggle = !this.icontoggle
        },
        // 切换伦敦金银


        // 获取品类，区分专业投资者或非专业投资者
        initWebpack(){

          var that = this

          if (that.global.ws && that.global.ws.readyState == 1) {

            getsymbol(that.global.ws) //可用交易品类 里面也有黄金白银挂单距离
                
          }

            that.global.ws.onmessage = function(evt){

                var data = atob(evt.data);
                var data2 = pako.inflateRaw(data);
                var arr = new Uint16Array(data2);
                var strData   = utf8ByteToUnicodeStr(arr);
                var obj = JSON.parse(strData)



                if(obj.act == 'get_enable'){
                    obj.arr.forEach(element => {
                        if(element.symbol == 'XAU' || element.symbol == 'GOLD'){
                            that.$store.state.goldstopsLevel = element.stopsLevel
                            that.$store.state.dealgold = element.symbol == 'XAU'?'XAU':(element.symbol == 'GOLD'?'GOLD':'')
                        }else if(element.symbol == 'XAG' || element.symbol == 'SILVER'){
                            that.$store.state.silverstopsLevel = element.stopsLevel
                            that.$store.state.dealsilver = element.symbol == 'XAG'?'XAG':(element.symbol == 'SILVER'?'SILVER':'')
                        }

                    });

                    if(that.$store.state.dealgold == 'XAU' && that.$store.state.dealsilver == 'XAG'){
                        that.$store.state.isprofession = true
                    }else if(that.$store.state.dealgold == 'GOLD' && that.$store.state.dealsilver == 'SILVER'){
                        that.$store.state.isprofession = false
                    }


                }

            }

        },

        // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},

        downCallback (mescroll) {

            setTimeout(() => {

                this.reload();

            }, 1000)
            

	    },

        // 监听网络状态
        updateOnlineStatus(e) {
            const { type } = e;
            if(this.onLine = type === 'online'){
                this.$store.state.tips = false
            }else{
                this.$store.state.tips = true
            }
        },
        // 销毁时解除事件监听
        beforeDestroy(){
            window.removeEventListener('online',  this.updateOnlineStatus);
            window.removeEventListener('offline', this.updateOnlineStatus);
        },

        // 获取昨收价
        getTomorrowPrice(){
            axios.get("https://trade.jrjr.com/ajax.php").then((response) => {
                this.goldclose = (response.data.data.GOLD.open + response.data.data.GOLD.close) /100
                this.silverclose = (response.data.data.SILVER.open + response.data.data.SILVER.close)/1000
            })
        }

    },

    watch:{
        // 'currentIndex'(val){ //由于切换账户之前如果客户停留在白银页面，切换之后会刷新页面所以要变为黄金页面true
        //     if(val == 0){
        //         this.$store.state.goldindex = true
        //     }else if(val == 1){
        //         this.$store.state.goldindex = false
        //     }
        //     console.log(val +'watch里goldindex')
        // }
    },

    created(){
        // this.localSockets()
        // this.initWebpack()
    },

    computed:{

        // 最新卖价-昨收价
        getTomgoldprice(){
            if((this.$store.state.goldSell - this.goldclose) > 0){
                return '+' + (this.$store.state.goldSell - this.goldclose).toFixed(2)
            }else if((this.$store.state.goldSell - this.goldclose) == 0){
                return '--.--'
            }else{
                return (this.$store.state.goldSell - this.goldclose).toFixed(2)
            }
        },

        getTomsilverprice(){
            if((this.$store.state.silverSell - this.silverclose) > 0){
                return '+' + (this.$store.state.silverSell - this.silverclose).toFixed(3)
            }else if((this.$store.state.silverSell - this.silverclose) == 0){
                return '--.--'
            }else{
                return (this.$store.state.silverSell - this.silverclose).toFixed(3)
            }
        },

        // 百分比
        getgoldclose(){
            if(((this.$store.state.goldSell - this.goldclose)/this.goldclose * 100) > 0){
                return '+' + ((this.$store.state.goldSell - this.goldclose)/this.goldclose * 100).toFixed(2) + '%' 
            }else if(((this.$store.state.goldSell - this.goldclose)/this.goldclose * 100) == 0){
                return '--.--'
            }else{
                return  ((this.$store.state.goldSell - this.goldclose)/this.goldclose * 100).toFixed(2) + '%' 
            }
        },
        getsilverclose(){
            if(((this.$store.state.silverSell - this.silverclose)/this.silverclose *100) > 0){
                return '+' + ((this.$store.state.silverSell - this.silverclose)/this.silverclose *100).toFixed(2) + '%'
            }else if(((this.$store.state.silverSell - this.silverclose)/this.silverclose *100) == 0){
                return '--.--'
            }else{
                return ((this.$store.state.silverSell - this.silverclose)/this.silverclose *100).toFixed(2) + '%'
            }
        }
    },

    mounted(){
        this.$emit('num',0)
        this.getTomorrowPrice()
        window.addEventListener('online',  this.updateOnlineStatus);// 网络由异常到正常时触发
 
		window.addEventListener('offline', this.updateOnlineStatus);// 网络由正常常到异常时触发

        // 禁止浏览器自带返回
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
        });

    }

}
</script>

<style scoped>
    body{touch-action: none;}
    li{list-style: none;}

    /* 断网提示 */
    .tips{padding: 9.33px 12px 10px 12px;display: flex;align-items: center;justify-content: space-between;align-items: center;border-radius: 6px;background-color: #FFF5F3;color: #FF4F36;}
    .tips span:nth-of-type(1){padding-left: 11.67px;}
    .tips span:nth-of-type(2){padding-right: 11.33px;}

    /* 和曲线图是一个组件 */
    .goldtitle{height: 32px;padding: 0 15px;display: flex;justify-content: flex-start;align-items: center;}
    .goldtitle p:nth-of-type(1){font-size: 14px;display: flex;justify-content: flex-start;align-items: center;}
    .goldtitle p:nth-of-type(1) span{color: #FF4F36;font-weight: bold;}
    .goldtitle p:nth-of-type(1) span:nth-of-type(1){color: #333333;}
    .goldtitle p:nth-of-type(1) span:nth-of-type(3){padding-left: 9px;}
    .goldtitle p img{width: 16px;height: 16px;display: block;}
    .goldtitle p:nth-of-type(2){font-size: 14px;display: flex;justify-content: flex-start;align-items: center;color: #999999;}
    .goldtitle p:nth-of-type(2) img{width: 18px;height: 18px;display: block;}

    /* 切换伦敦金银 */
    .slideDown{width: 100px;border-radius: 6px;background: rgba(0, 0, 0, 0.6);position: absolute;left: -12px;top: 30.67px;display: flex;justify-content: center;align-items: center;flex-wrap: wrap;padding-bottom: 11.33px;z-index: 999;flex-direction: column;}
    .slideDown li{padding-top: 10px;color: #FFFFFF;font-size: 14px;}
    .tab-item{text-decoration: none;}
    .tab-icon{display: block !important;position: absolute !important;top: -7px !important;left: 24px !important;border-left: 7px solid transparent;border-right: 7px solid transparent;border-bottom: 7px solid rgba(0, 0, 0, 0.6);}

    /*通过fixed固定mescroll的高度*/
	.mescroll {position: fixed;top: 82px;bottom: 0;height: auto;z-index: 885;}
</style>


// WEBPACK FOOTER //
// src/pages/deal.vue